export default "__VITE_ASSET__CvHD94bq__"